'use strict';

var index = require('../../index-c6190cd6.js');

function IconWrapper({ fontSize = "medium", children = null, className = "", } = {}) {
    const fontSizePx = fontSize === "small" ? "16px" : "20px";
    const margin = fontSize === "small" ? "-2px 0" : undefined;
    return (index.React.createElement("i", { style: {
            fontSize: fontSizePx,
            margin,
            display: "inline-block",
            fontStyle: "normal",
            lineHeight: "0",
            textAlign: "center",
            textTransform: "none",
            verticalAlign: "-.125em",
            textRendering: "optimizeLegibility",
            // @ts-ignore
            WebkitFontSmoothing: "antialiased",
            // @ts-ignore
            MozOsxFontSmoothing: "grayscale",
        }, className: className }, children));
}

module.exports = IconWrapper;
